import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import UserService from "../services/EmployeeService";
import Breadcrumb from "../components/Breadcrumb";
import StorageService from "../services/StorageService";
import usePermission from "../utils/UsePermission";
import ScreenData from "../config/ScreenData";
import UnAuthorized from "../views/Unathorized";
import ReactPaginate from "react-paginate";
import MessageDialog from "../components/MessageDialog";
import utility from "../utils/utility";

export default function ViewEmployees() {
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState(null);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [loading, setLoading] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const searchTimer = useRef(null);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewData, setViewData] = useState(null);
  const { roleId } = StorageService.loginData();
  const isSuperAdmin = roleId === "1";

  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  // const fetchUsers = async () => {
  //   setLoading(true);
  //   try {
  //     const res = await UserService.getAllUsers(
  //       StorageService.activeCompany().companyId
  //     );
  //     setUsers(res || []);
  //   } catch (err) {
  //     console.error("Error fetching users:", err);
  //     showMessage("Failed to fetch users", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  const { permission, can } = usePermission(
    ScreenData.Employee,
    showMessage
  );

  useEffect(() => {
    if (permission === null) return;

    if (permission.canView !== 1) {
      setLoading(false);
      return;
    }

    fetchUsers();
  }, [search, currentPage, permission]);

  useEffect(() => {
    setCurrentPage(1);
  }, [search]);




  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const handleSelect = (id) => {
    setSelected(id);
  };

  // const handleSelectAll = (e) =>
  //   setSelected(e.target.checked ? users.map((u) => u.id) : []);

  const handleAdd = () => {
    navigate("/cpnl/users/add");
  };

  const handleModify = () => {
    if (!selected)
      return showMessage(
        selected.length === 0
          ? "Select one user to modify."
          : "Select only one user."
      );
    const id = selected;
    navigate(`/cpnl/users/add/${id}`);
  };

  const handleView = async () => {
    if (!selected) {
      showMessage(
        selected.length === 0
          ? "Select one employee to view."
          : "Select only one employee.",
        "error"
      );
      return;
    }

    const id = selected;

    try {
      setLoading(true);
      const data = await UserService.getById(id);

      if (!data) {
        showMessage("Failed to load employee details", "error");
        return;
      }

      setViewData(data);
      setShowViewModal(true);
    } catch (err) {
      console.error(err);
      showMessage("Error loading employee details", "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const res = await UserService.getAllUsers(
        StorageService.activeCompany().companyId,
        search,
        currentPage,
        itemsPerPage
      );
      setUsers(res.data || []);
      setPageCount(res.pagination.totalPages || 1);
    } catch (err) {
      console.error("Error fetching users:", err);
      showMessage("Failed to fetch users", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (value) => {
    if (searchTimer.current) clearTimeout(searchTimer.current);

    searchTimer.current = setTimeout(() => {
      setSearch(value);
    }, 400);
  };

  const handleMenuAccess = () => {
    if (!selected)
      return showMessage(
        selected.length === 0
          ? "Select one user to access menu."
          : "Select only one user."
      );

    const id = selected;
    navigate(`/cpnl/employee/menu/${id}`);
  };

  // const handleToggleStatus = async (user) => {
  //   const newStatus = user.status === "Active" ? "Inactive" : "Active";
  //   if (!window.confirm(`Are you sure  do you want to  change status as ${newStatus}?`))
  //     return;

  //   setLoading(true);
  //   try {
  //     await UserService.updateUser(user.id, { ...user, status: newStatus });
  //     setUsers((prev) =>
  //       prev.map((u) => (u.id === user.id ? { ...u, status: newStatus } : u))
  //     );
  //     showMessage(`User marked as ${newStatus}.`, "success");
  //   } catch (err) {
  //     console.error(err);
  //     showMessage("Error updating status", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleToggleStatus = async (user) => {
    const newStatus = user.status === "Active" ? "Inactive" : "Active";

    if (!window.confirm(`Are you sure do you want to change status as ${newStatus}?`))
      return;

    setLoading(true);

    try {
      // CALL STATUS API (NO VALIDATION ISSUE)
      await UserService.toggleStatus(user.id);

      // UPDATE UI
      setUsers((prev) =>
        prev.map((u) =>
          u.id === user.id ? { ...u, status: newStatus } : u
        )
      );

      showMessage(`User marked as ${newStatus}.`, "success");

    } catch (err) {
      console.error(err);
      showMessage("Error updating status", "error");
    } finally {
      setLoading(false);
    }
  };

  const getStatusClass = (status) =>
    status === "Active" ? "bg-success" : "bg-secondary";
  const getToggleText = (status) =>
    status === "Active" ? "Inactivate" : "Activate";

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewData(null);
  };

  // if (permission === null) {
  //   return <div className="text-center mt-5">Loading...</div>;
  // }

  if (!permission || permission.canView !== 1) {
    return <UnAuthorized />;
  }

  return (
    <>
      <Breadcrumb
        pageTitle="Employees"
        secondTitle="Employee Management"
      ></Breadcrumb>

      <div className="row">
        <div className="card p-3 bg-white shadow-sm">
          {/* {message && (
            <div
              className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
                } d-flex justify-content-between align-items-center mb-2 p-2`}
            >
              <span>{message}</span>
              <button
                type="button"
                className="btn-close"
                onClick={closeMessage}
              ></button>
            </div>
          )} */}

          <MessageDialog
            message={message}
            type={msgType}
            setMessage={setMessage}
            setMsgType={setMsgType}
          />

          <div
            className="d-flex justify-content-between align-items-center mb-2 pb-2"
            style={{ borderBottom: "1px solid #e9ecef", gap: "10px" }}
          >
            {/*  LEFT: SEARCH */}
            <div style={{ width: "350px" }}>
              <input
                type="text"
                className="form-control"
                placeholder="Search employee name..."
                onChange={(e) => handleSearchChange(e.target.value)}
              />
            </div>

            {/*  RIGHT: BUTTONS */}
            <div className="d-flex flex-wrap gap-2 justify-content-end">
              {can("canAdd") && (
                <button
                  className="btn btn-success"
                  onClick={handleAdd}
                  disabled={loading}
                >
                  <i className="ti ti-plus me-1"></i> Add
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-warning"
                  onClick={handleModify}
                  disabled={!selected || loading}
                >
                  <i className="ti ti-pencil me-1"></i> Modify
                </button>
              )}

              {can("canView") && (
                <button
                  className="btn btn-primary"
                  onClick={handleView}
                  disabled={!selected || loading}
                >
                  <i className="ti ti-eye me-1"></i> View
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-secondary"
                  onClick={handleMenuAccess}
                  disabled={!selected || loading}
                >
                  <i className="ti ti-menu-2 me-1"></i> Menu Access
                </button>
              )}

              {can("canModify") && (
                <button
                  className="btn btn-info"
                  title={
                    !isSuperAdmin
                      ? "Only Super Admin can reset passwords"
                      : !selected
                        ? "Select one user to reset password"
                        : "Reset Password"
                  }
                  onClick={() => {
                    if (!selected) {
                      showMessage("Select one user to reset password.");
                      return;
                    }
                    setShowResetModal(true);
                  }}
                  disabled={!selected || loading || !isSuperAdmin}
                >
                  <i className="ti ti-refresh me-1"></i> Reset Password
                </button>
              )}

            </div>
          </div>


          {/*  Password Reset Popup */}
          {showResetModal && (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.5)",
                zIndex: 999,
              }}
            >
              <div
                style={{
                  position: "fixed",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "400px",
                  background: "#fff",
                  padding: "20px",
                  borderRadius: "8px",
                  zIndex: 1000,
                }}
              >
                <h5 className="mb-3">Reset Password</h5>
                {/* Eye icon show/hide functionality */}

                <div className="mb-3">
                  <label className="form-label">New Password</label>
                  <div className="input-group">
                    <input
                      type={showNewPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Enter new password"
                      value={newPassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowNewPassword(!showNewPassword)}
                    >
                      <i className={showNewPassword ? "ti ti-eye" : "ti ti-eye-off"}></i>
                    </button>
                  </div>
                </div>

                <div className="mb-3">
                  <label className="form-label">Confirm Password</label>
                  <div className="input-group">
                    <input
                      type={showConfirmPassword ? "text" : "password"}
                      className="form-control"
                      placeholder="Confirm password"
                      value={confirmPassword || ""}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
                    <button
                      type="button"
                      className="btn btn-outline-secondary"
                      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    >
                      <i
                        className={
                          showConfirmPassword ? "ti ti-eye" : "ti ti-eye-off"
                        }
                      ></i>
                    </button>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3">
                  <button
                    className="btn btn-secondary"
                    onClick={() => setShowResetModal(false)}
                  >
                    Cancel
                  </button>

                  <button
                    className="btn btn-primary"
                    onClick={async () => {
                      const employeeId = selected;

                      if (!newPassword || !confirmPassword) {
                        showMessage("Please enter both password fields.", "error");
                        return;
                      }

                      if (newPassword.length < 6 || newPassword.length > 8) {
                        showMessage("Password must be between 6 and 8 characters", "error");
                        return;
                      }

                      if (newPassword !== confirmPassword) {
                        showMessage("Passwords do not match.", "error");
                        return;
                      }

                      try {
                        const res = await UserService.resetPassword(employeeId, newPassword);
                        if (res.status) {
                          showMessage("Password reset successfully!", "success");
                          setShowResetModal(false);
                          setNewPassword("");
                          setConfirmPassword("");
                        } else {
                          showMessage(res.message || "Failed to reset password.", "error");
                        }
                      } catch (err) {
                        console.error(err);
                        showMessage("Error resetting password.", "error");
                      }
                    }}
                  >Save
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Table */}
          <div className="table-responsive">
            <table className="table table-striped table-bordered mb-0">
              <thead className="table-light">
                <tr>
                  <th>Select
                  </th>
                  {/* <th>Profile Pic</th> */}
                  {"User ID,First Name,Last Name,Mobile,Email,Gender,Role,Reporting Manager,DOJ,State,District,ZIP,Status"
                    .split(",")
                    .map((col) => (
                      <th key={col}>{col}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="17" className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        style={{ width: "3rem", height: "3rem" }}
                      ></div>
                    </td>
                  </tr>
                ) : users.length > 0 ? (
                  users.map((user) => (
                    <tr key={user.id}>
                      <td>
                        <input
                          type="radio"
                          name="employeeSelect"
                          checked={selected === user.id}
                          onChange={() => handleSelect(user.id)}
                        />
                      </td>

                      <td>{user.loginId || "-"}</td>
                      <td>{user.firstName}</td>
                      <td>{user.lastName}</td>
                      <td>{user.mobileNo}</td>
                      <td>{user.emailId}</td>
                      <td>{user.gender}</td>
                      <td>{user.roleName}</td>
                      <td>{user.managerName || "-"}</td>
                      <td>
                        {user.doj
                          ? utility.formatDateDDMMMYYYY(user.doj)
                          : "-"}
                      </td>
                      <td>{user.stateName}</td>
                      <td>{user.cityName}</td>
                      <td>{user.zip}</td>
                      <td>
                        {can("canModify") && (
                          <button
                            type="button"
                            className={`badge border-0 ${getStatusClass(user.status)}`}
                            style={{ cursor: "pointer" }}
                            onClick={() => handleToggleStatus(user)}
                            disabled={loading}
                          >
                            {user.status}
                          </button>
                        )}
                      </td>
                      {/* <td>
                        <button
                          className="btn btn-sm btn-primary me-2"
                          onClick={() => handleToggleStatus(user)}
                          disabled={loading}
                        >
                          {getToggleText(user.status)}
                        </button>
                      </td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="17" className="text-center text-muted">
                      No users found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            <ReactPaginate
              // forcePage={currentPage - 1}
              forcePage={Math.max(0, currentPage - 1)}
              breakLabel="..."
              nextLabel="Next >"
              previousLabel="< Previous"
              onPageChange={(e) => setCurrentPage(e.selected + 1)}
              pageCount={pageCount}   // ✅ IMPORTANT
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              containerClassName="pagination-container"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              activeClassName="active"
            />
          </div>
        </div>
      </div>
      {showViewModal && viewData && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 999,
          }}
        >
          <div
            style={{
              position: "fixed",
              top: "55%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "750px",
              background: "#fff",
              borderRadius: "10px",
              maxHeight: "88vh",
              display: "flex",
              flexDirection: "column",
              zIndex: 1000,
            }}
          >
            {/* HEADER */}
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                padding: "16px 20px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <h5 className="mb-0">Employee Details</h5>
              <button
                className="btn btn-sm btn-outline-secondary"
                onClick={closeViewModal}
              >
                <i className="ti ti-x"></i>
              </button>
            </div>

            {/* BODY */}
            <div style={{ padding: "20px", overflowY: "auto" }}>

              <div className="row">

                {/* LEFT COLUMN */}
                <div className="col-md-6">
                  <Field label="Employee Code" value={viewData.employeeCode} />
                  <Field label="First Name" value={viewData.firstName} />
                  <Field label="Email" value={viewData.emailId} />
                  <Field label="Gender" value={viewData.gender} />
                  <Field label="Address" value={viewData.address} />
                  <Field label="Country" value={viewData.countryName} />
                  <Field label="District" value={viewData.cityName} />
                  <Field label="ZIP" value={viewData.zip} />
                  <Field label="Reporting Manager" value={viewData.managerName} />
                  <Field
                    label="Created By"
                    value={
                      viewData.createdByName
                        ? `${viewData.createdByName}${viewData.createdByCode ? ` - ${viewData.createdByCode}` : ""}`
                        : "-"
                    }
                  />


                </div>  {/*  CLOSE LEFT COLUMN */}

                {/* RIGHT COLUMN */}
                <div className="col-md-6">
                  <Field label="User ID" value={viewData.loginId} />
                  <Field label="Last Name" value={viewData.lastName} />
                  <Field label="Mobile No" value={viewData.mobileNo} />
                  <Field label="Role" value={viewData.roleName} />
                  <Field label="Landmark" value={viewData.landmark} />
                  <Field label="State" value={viewData.stateName} />
                  <Field
                    label="Date of Joining"
                    value={viewData.doj ? utility.formatDateDDMMMYYYY(viewData.doj) : ""}
                  />
                  <Field
                    label="Date of Resignation"
                    value={viewData.dor ? utility.formatDateDDMMMYYYY(viewData.dor) : ""}
                  />
                  <Field label="Status" value={viewData.status} />
                  <Field
                    label="Updated By"
                    value={
                      viewData.updatedByName
                        ? `${viewData.updatedByName}${viewData.updatedByCode ? ` - ${viewData.updatedByCode}` : ""}`
                        : "-"
                    }
                  />
                </div>

              </div>

              {/* FOOTER */}
              <div className="d-flex justify-content-end mt-2">
                <button className="btn btn-secondary" onClick={closeViewModal}>
                  <i className="ti ti-cancel me-1"></i> Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
function Field({ label, value }) {
  return (
    <div className="mb-3">
      <label className="form-label">{label}</label>
      <input
        className="form-control"
        readOnly
        value={value || "-"}
        style={{
          backgroundColor: "#f8f9fa",
          color: "#000",
          fontWeight: "600",
          borderColor: "#ced4da",
        }}
      />
    </div>
  );
}

